export default "__VITE_ASSET__B6KY7_hD__"